import { Row, Col, Accordion } from "react-bootstrap";
import { Input, Timeline, Header, PageWrapper } from "../../components";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { getOrderDetail } from "../../api/order";
import { DATETIME_FORMAT } from "../../shared/constants";
import { LocalStorageKey, Role } from "../../shared/enums";

const OrderDetail = ({ }) => {
    const { t } = useTranslation()
    const { id } = useParams()
    const [orderDetail, setOrderDetail] = useState(null)
    const [userData] = useState(
        JSON.parse(localStorage.getItem(LocalStorageKey.USER_DATA))
    );

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const response = await getOrderDetail(id)
        setOrderDetail(response)
    }

    return <PageWrapper headerProps={{ title: "ORDER_DETAIL" }}>
        {orderDetail && <>
            <Accordion defaultActiveKey={'0'} className="mb-4">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{t("ORDER_DETAIL")}</Accordion.Header>
                    <Accordion.Body>
                        <Input label={t("CREATED_AT")} formControlProps={{ disabled: true, value: dayjs(orderDetail?.createdAt).format(DATETIME_FORMAT) }} />
                        <Row>
                            <Col>
                                <Input label={t("TYPE")} formControlProps={{ disabled: true, value: orderDetail?.driverType }} />
                            </Col>
                            <Col>
                                <Input label={t("AMOUNT")} formControlProps={{ disabled: true, value: orderDetail?.currency + " " + orderDetail?.amount }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input label={t("SST")} formControlProps={{ disabled: true, value: orderDetail?.currency + " " + (orderDetail?.sstAmount || 0).toFixed(2) }} />
                            </Col>
                            <Col>
                                <Input label={t("TOTAL")} formControlProps={{ disabled: true, value: orderDetail?.currency + " " +  (+(orderDetail?.amount || 0) + +(orderDetail?.sstAmount || 0)).toFixed(2) }} />
                            </Col>
                        </Row>
                        {(userData?.roles.includes(Role.ADMIN) || userData?.roles.includes(Role.SUPER_ADMIN)) &&
                            <Row>
                                <Col>
                                    <Input label={t("CHARGES_PERCENTAGE")} formControlProps={{ disabled: true, value: orderDetail?.companyCommissionPercentage ? orderDetail?.companyCommissionPercentage + "%" : (orderDetail?.companyCommission && orderDetail?.amount) ? ((orderDetail?.companyCommission / orderDetail?.amount) * 100) + "%" : "-" }} />
                                </Col>
                                <Col>
                                    <Input label={t("CHARGES_AMOUNT")} formControlProps={{ disabled: true, value: orderDetail?.companyCommission ? orderDetail?.currency + " " + orderDetail?.companyCommission.toFixed(2) : "-" }} />
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col>
                                <Input label={t("START_AT")} formControlProps={{ disabled: true, value: dayjs(orderDetail?.locationDetails?.fromDateTime).format(DATETIME_FORMAT) }} />
                            </Col>
                            <Col>
                                <Input label={t("END_AT")} formControlProps={{ disabled: true, value: dayjs(orderDetail?.locationDetails?.toDateTime).format(DATETIME_FORMAT) }} />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Input label={t("DEPARTURE_LOCATION")} formControlProps={{ disabled: true, value: orderDetail?.locationDetails?.depAddress }} />
                            </Col>
                            <Col>
                                <Input label={t("DESTINATION_LOCATION")} formControlProps={{ disabled: true, value: orderDetail?.locationDetails?.desAddress }} />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Input label={t("FARE_START_AT")} formControlProps={{ disabled: true, value: dayjs(orderDetail?.locationDetails?.fromDateTime).format(DATETIME_FORMAT) }} />
                            </Col>
                            <Col>
                                <Input label={t("FARE_END_AT")} formControlProps={{ disabled: true, value: dayjs(orderDetail?.locationDetails?.toDateTime).format(DATETIME_FORMAT) }} />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Input label={t("DEPARTURE_POINT")} formControlProps={{ disabled: true, value: `${orderDetail?.locationDetails?.depLat}, ${orderDetail?.locationDetails?.depLong}` }} />
                            </Col>
                            <Col>
                                <Input label={t("DESTINATION_POINT")} formControlProps={{ disabled: true, value: `${orderDetail?.locationDetails?.desLat}, ${orderDetail?.locationDetails?.desLong}` }} />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Input label={t("STATUS")} formControlProps={{ disabled: true, value: orderDetail?.status }} />
                            </Col>
                            <Col>
                                <Input label={t("STATUS_DESCRIPTION")} formControlProps={{ disabled: true, value: orderDetail?.statusDesc }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input label={t("RATING")} formControlProps={{ disabled: true, value: _.isNil(orderDetail?.rating) ? "-" : orderDetail?.rating }} />
                            </Col>
                            <Col>
                                <Input label={t("TIPS")} formControlProps={{ disabled: true, value: _.isNil(orderDetail?.tips) ? "-" : `${orderDetail?.currency} ${orderDetail?.tips}` }} />
                            </Col>
                        </Row>
                        <Input rows={3} label={t("COMMENT")} formControlProps={{ disabled: true, value: orderDetail?.comment || "-" }} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion defaultActiveKey={'0'} className="my-4">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{t("STATUS_HISTORY")}</Accordion.Header>
                    <Accordion.Body>
                        <Timeline data={orderDetail?.statusHistory.map(e => ({ title: e.status, datetime: dayjs(e.datetime).format(DATETIME_FORMAT) }))} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion defaultActiveKey={'0'} className="mb-4">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{t("DRIVER_INFORMATION")}</Accordion.Header>
                    <Accordion.Body>
                        <Input label={t("FULL_NAME")} formControlProps={{ disabled: true, value: orderDetail?.driverDetails?.fullName || "-" }} />
                        <Input label={t("PHONE_NUMBER")} formControlProps={{ disabled: true, value: orderDetail?.driverDetails?.countryCode + orderDetail?.driverDetails?.phoneNumber || "-" }} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion defaultActiveKey={'0'} className="mb-4">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{t("USER_INFORMATION")}</Accordion.Header>
                    <Accordion.Body>
                        <Input label={t("FULL_NAME")} formControlProps={{ disabled: true, value: orderDetail?.userDetails?.fullName || "-" }} />
                        <Input label={t("PHONE_NUMBER")} formControlProps={{ disabled: true, value: orderDetail?.userDetails?.countryCode + orderDetail?.userDetails?.phoneNumber || "-" }} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion defaultActiveKey={'0'} className="mb-4">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{t("VEHICLE")}</Accordion.Header>
                    <Accordion.Body>
                        <Input label={t("TYPE")} formControlProps={{ disabled: true, value: orderDetail?.vehicleType?.name || "-" }} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
        }
    </PageWrapper>
}

export default OrderDetail;